import ContentfulRichTextRender from './contentfulRichTextRender.component';

export * from './contentfulRichTextRender.types';
export default ContentfulRichTextRender;
